import React, { useState } from "react";
import "./webhooksTable.css";
import { updateMerchantWebhooks } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import ConfirmAction from "./ConfirmAction";

const EditWebhookModal = ({ webhook, token, onClose, onUpdate }) => {
  const [payinURL, setPayinURL] = useState(webhook.payinURL);
  const [payoutURL, setPayoutURL] = useState(webhook.payoutURL);
  const [isUpdating, setIsUpdating] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSave = async () => {
    setIsUpdating(true);
    try {
      await updateMerchantWebhooks(
        webhook.webhookId,
        { payinURL, payoutURL },
        token
      );
      toast.success("Webhook updated successfully!");
      onUpdate();
      onClose();
    } catch (error) {
      toast.error("Failed to update webhook.");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="webhooks-modal-overlay">
      <div className="webhooks-modal-content">
        <h3>Update Webhook</h3>
        <p>
          Merchant Name :{" "}
          <strong className="merchnatName">{webhook.merchantName}</strong>{" "}
        </p>

        <label>Payin URL:</label>
        <input
          type="text"
          value={payinURL}
          onChange={(e) => setPayinURL(e.target.value)}
          disabled={isUpdating}
        />

        <label>Payout URL:</label>
        <input
          type="text"
          value={payoutURL}
          onChange={(e) => setPayoutURL(e.target.value)}
          disabled={isUpdating}
        />

        <div className="webhooks-modal-buttons">
          <button onClick={() => setShowConfirm(true)} disabled={isUpdating}>
            {isUpdating ? "Updating..." : "Update"}
          </button>
          <button onClick={onClose} disabled={isUpdating}>
            Cancel
          </button>
        </div>
      </div>
      {showConfirm && (
        <ConfirmAction
          message={`Are you sure you want to update ${webhook.merchantName} webhooks?`}
          onConfirm={handleSave}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default EditWebhookModal;
